import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import electionApi from '~/clientApis/electionApi';
import { CopyElectionRequest } from '~/definitions/election';

export const copyElection = async (data: CopyElectionRequest): Promise<void> => {
    const { adminStore } = getStore();

    adminStore.setIsCopyingElection(true);

    try {
        // Send API request to copy election
        const res = await electionApi.copyElection(data);
        const newElectionId = res?.data?.resourceId || '';
        if (newElectionId === '') {
            return;
        }
        // Fetch updated admin data
        await adminStore.fetchAdminData();
    } catch (error) {
        showMessageModal('error', 'Failed to copy election');
    } finally {
        adminStore.setIsCopyingElection(false);
    }
};
